import { FC, ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'

interface InfoBarProps {
    children: ReactNode
    color: string
}

const InfoBar: FC<InfoBarProps> = ({ children, color }) => {
    return <View style={[styles.container, { backgroundColor: color }]}>{children}</View>
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTopStartRadius: 4,
        borderTopEndRadius: 4,
        height: 52,
    },
})

export default InfoBar
